var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFullTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 20,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M253.4,21.3C123.8,21.3,18.7,126.4,18.7,256s105.1,234.7,234.7,234.7S488,385.6,488,256C487.9,126.5,382.9,21.5,253.4,21.3z  M253.4,448c-106,0-192-86-192-192s86-192,192-192s192,86,192,192C445.2,362,359.4,447.9,253.4,448z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M274.7,247.2V128c0-11.8-9.6-21.3-21.3-21.3c-11.8,0-21.3,9.6-21.3,21.3v128c0,5.7,2.2,11.1,6.3,15.1l64,64 c8.5,8.2,22,8,30.2-0.5c8-8.3,8-21.4,0-29.6L274.7,247.2z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullTime);
export default __webpack_public_path__ + "static/media/full-time.8f44ae5c.svg";
export { ForwardRef as ReactComponent };